export default {
  user: null,
  project: null,
  calls: [],
  weekStats: [],
  accountBalance: null,
  message: {
    message: null,
    color: "info"
  },
  loadingPage: false
};
